import { takeLatest, put, select, call, all } from 'typed-redux-saga/macro';
import { setInstalledBankAppsAction, } from 'actions/linkBank';
import { BANKS_SUCCESS } from 'actions/types';
import { isAppInstalledAndroid, isAppInstalledIOS } from 'utils/linking';
import { selectInstalledBankApps, selectShowInstalledBankApps, } from 'features/link-bank/selectors/selectors';
import { isNotNullable } from 'utils/isNotNullable';
import { BANK_APPS } from 'features/link-bank/utils';
import Sentry from 'utils/sentry';
import { isIOS, isAndroid } from '../constants';
function* findInstalledBankAppsWorker(action) {
    const showInstalledApps = yield* select(selectShowInstalledBankApps);
    const hasInstalledBankApps = yield* select(selectInstalledBankApps);
    const { banks } = action.payload;
    if ((!isIOS && !isAndroid) ||
        !showInstalledApps ||
        hasInstalledBankApps?.length ||
        !banks?.length) {
        return;
    }
    const candidates = banks
        .map((bank) => {
        const identifier = isIOS
            ? BANK_APPS[bank.name]?.iosUriScheme
            : BANK_APPS[bank.name]?.androidPackageName;
        return identifier ? { id: bank.id, identifier } : undefined;
    })
        .filter(isNotNullable);
    let results = [];
    try {
        results = yield* all(candidates.map(({ identifier }) => call(isIOS ? isAppInstalledIOS : isAppInstalledAndroid, identifier)));
    }
    catch (error) {
        Sentry.logError({
            err: error,
            message: 'Failed to check if app is installed',
        });
    }
    const installedBankApps = candidates
        .filter((_, index) => results[index])
        .map(({ id }) => id);
    yield* put(setInstalledBankAppsAction(installedBankApps));
}
function* accountsSaga() {
    yield* takeLatest(BANKS_SUCCESS, findInstalledBankAppsWorker);
}
export default accountsSaga;
